import { mobileAppLight, mobileAppDark } from './mobile';
import { pcAppDark, pcAppLight, pcWencaiLight } from './pc';
import { businessTreemapMarketLight } from './business';

export type PresetTheme = typeof mobileAppLight['name'];

export default [
  mobileAppLight,
  mobileAppDark,
  pcAppDark,
  pcAppLight,
  pcWencaiLight,
  businessTreemapMarketLight
];
